import React from 'react';

import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

import {isSQLTemplateFormStateValid} from './interpolation/makeSQLInterpolationInput';
import runConfirmEditSQLModal from './runConfirmEditSQLModal';
import {isFormStateInitialized, SQLTemplateFormState} from './SQLTemplateFormTypes';

export interface EditSQLButtonProps {
  editSQL: () => void;
  sqlTemplateFormState: SQLTemplateFormState;
}

export default function EditSQLButton(props: EditSQLButtonProps): JSX.Element {
  const isDisabled =
    isFormStateInitialized(props.sqlTemplateFormState) &&
    !isSQLTemplateFormStateValid(props.sqlTemplateFormState);

  async function handleClick(): Promise<void> {
    if (await runConfirmEditSQLModal()) {
      props.editSQL();
    }
  }

  return (
    <Tooltip
      disabled={!isDisabled}
      title="The form has errors that must be fixed before editing the SQL"
      placement={TooltipPlacement.TOP}
    >
      <Button
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        disabled={isDisabled}
        onClick={handleClick}
        size={ButtonSize.MINI}
        text="Edit SQL"
        dataTestAttrs={{component: 'EditSQLButton', element: 'button'}}
      />
    </Tooltip>
  );
}
